"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.utils = exports.splConstants = exports.MallocSPLBuildActionMap = exports.SolendAction = exports.TransferAction = void 0;
const raydiumUtils = __importStar(require("./raydium/raydium-utils"));
const raydium_swap_1 = require("./raydium/raydium-swap");
const raydium_lp_deposit_1 = require("./raydium/raydium-lp-deposit");
// import MintAction from "./mint";
// import { MintAndMintToAction } from "./mint-to";
const solend_lp_deposit_1 = require("./solend/solend-lp-deposit");
// import SwapAction from "./swap";
const transfer_1 = require("./transfer");
const raydium_lp_stake_1 = require("./raydium/raydium-lp-stake");
// export { SwapAction } from "./swap";
var transfer_2 = require("./transfer");
Object.defineProperty(exports, "TransferAction", { enumerable: true, get: function () { return transfer_2.TransferAction; } });
// export { MintAction } from "./mint";
// export { MintAndMintToAction } from "./mint-to";
var solend_lp_deposit_2 = require("./solend/solend-lp-deposit");
Object.defineProperty(exports, "SolendAction", { enumerable: true, get: function () { return solend_lp_deposit_2.SolendLpDepositAction; } });
exports.MallocSPLBuildActionMap = {};
const CPI_ACTION_PID = "muZ8k7AinSTHUwyDU34FL9Ebfy2SdAPHFbMLpnUC6yM";
exports.splConstants = {
    BUILD_ACTION_UIDS: {
        TRANSFER: transfer_1.TransferAction.actionTypeUID,
        RAYDIUM_SWAP: raydium_swap_1.RaydiumSwapAction.actionTypeUID,
        RAYDIUM_LP_DEPOSIT: raydium_lp_deposit_1.RaydiumLPDepositAction.actionTypeUID,
        RAYDIUM_LP_STAKE: raydium_lp_stake_1.RaydiumLPStakeAction.actionTypeUID,
        SOLEND_LP_DEPOSIT: solend_lp_deposit_1.SolendLpDepositAction.actionTypeUID,
    },
    HELPER_UIDS: {
        RAYDIUM_SWAP: raydium_swap_1.RaydiumSwapAction,
    },
    PIDS: {
        DEVNET: { CPI_ACTION: CPI_ACTION_PID },
        MAINNET: {
            CPI_ACTION: CPI_ACTION_PID,
            TRANSFER: CPI_ACTION_PID,
            RAYDIUM_SWAP: CPI_ACTION_PID,
            RAYDIUM_LP_DEPOSIT: CPI_ACTION_PID,
            RAYDIUM_LP_STAKE: CPI_ACTION_PID,
            SOLEND_LP_DEPOSIT: CPI_ACTION_PID,
        },
    },
};
// Add the spl actions to the default mapping
const addActionToMap = (actionLib) => {
    exports.MallocSPLBuildActionMap[actionLib.actionTypeUID] = actionLib;
};
// addActionToMap(SwapAction);
addActionToMap(transfer_1.TransferAction);
addActionToMap(raydium_lp_deposit_1.RaydiumLPDepositAction);
// addActionToMap(MintAction);
// addActionToMap(MintAndMintToAction);
addActionToMap(solend_lp_deposit_1.SolendLpDepositAction);
addActionToMap(raydium_swap_1.RaydiumSwapAction);
addActionToMap(raydium_lp_stake_1.RaydiumLPStakeAction);
exports.utils = {
    raydium: raydiumUtils,
};
